import type * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import type { IconDefinition } from '@gitbook/spine-react';

/**
 * Definitions for the agent tasks.
 */
export const AGENT_TASKS_DEF: {
    [type in api.AIMessageTask['type']]: {
        icon: IconDefinition;
        label: string;
    };
} = {
    respond_to_comment: {
        icon: Icon.CommentThread,
        label: 'Responding to a comment',
    },
    review_change_request: {
        icon: Icon.ChangeRequestOpen,
        label: 'Reviewing change request',
    },
    implement_change_request: {
        icon: Icon.ChangeRequestDraft,
        label: 'Implementing change request',
    },
};
